import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from "react-redux";
import { baseURL, getComments } from "../redux/Action";
import Details from "./Details";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlogDetails = () => {
  const { comments, user, isAuth, token } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [blog, setBlog] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [show, setShow] = useState(false);
  const [likes, setLikes] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = `Blogshog | Blog-${id}`;
    getBlog();
    getLikes();
    getComments(dispatch, id);
  }, []);

  const notify = (msg) => toast(msg, { theme: "dark" });

  const getBlog = () => {
    setIsLoading(true);
    axios
      .get(`${baseURL}/blogs/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        setBlog(res.data);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
        setIsLoading(false);
      });
  };
  const getLikes = () => {
    axios
      .get(`${baseURL}/likes/${id}`)
      .then((res) => {
        setLikes(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsError(true);
        setIsLoading(false);
      });
  };

  const like = () => {
    if (!isAuth) {
      return navigate("/login");
    }
    const payload = {
      blog_id: id,
      emoji: "",
    };

    axios
      .post(`${baseURL}/likes/`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.message) {
          notify(res.data.message);
        } else {
          notify(res.data);
        }
        getLikes();
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : isError ? (
        <Stack
          sx={{ width: "60%", margin: "2rem auto", height: "100vh" }}
          spacing={2}
        >
          <Alert severity="error">Something went wrong</Alert>
        </Stack>
      ) : (
        <>
          {blog.map((el, i) => {
            let published = new Date(el.createdAt.substring(0, 10));
            const updated = new Date(el.updatedAt);
            return (
              <Details
                key={i}
                published={published}
                like={like}
                comments={comments}
                el={el}
                updated={updated}
                id={id}
                likes={likes}
                setShow={setShow}
                show={show}
                user={user}
              />
            );
          })}
        </>
      )}
    </>
  );
};

export default BlogDetails;
